class CstmLocale extends HTMLElement {
  constructor() {
    super();
    this.localizationDropdown = this.querySelector("#FooterLocalizationForm");
    this.localizationLinks = this.localizationDropdown?.querySelectorAll(".location-drop-link") || [];
  }

  connectedCallback() {
    this.localizationLinks.forEach((link) => {
      link.addEventListener("click", this.handleLocalizationLinkClick.bind(this));
    });
  }

  handleLocalizationLinkClick(event) {
    event.preventDefault();
    const countryCode = event.currentTarget.dataset.countryCode;
    const localeCode = event.currentTarget.dataset.localeCode;
    
    if (countryCode && localeCode) {
      this.localizationDropdown.querySelector("input[name='country_code']").value = countryCode;
      this.localizationDropdown.querySelector("input[name='locale_code']").value = localeCode;
      this.localizationDropdown.submit();
    }
  }
}

customElements.define("cstm-locale", CstmLocale);
